import React from 'react';
import styles from './ProgressBar.module.css';

const ProgressStep = ({
                          segmentIndex,
                          stepNumber,
                          isActive,
                          isCompleted,
                          isFirst,
                          isLast,
                          isVisible,
                          label,
                          myAccount,
                          progressStep,
                      }) => {
    // Determine if this segment should be half-filled:
    const fraction = progressStep % 1;
    const halfIndex = Math.floor(progressStep) - 1; // zero-based
    const isHalfLine = fraction === 0.5 && segmentIndex === halfIndex;

    // Build line classes
    const lineClassName = () => {
        if (isLast) return null;
        if (myAccount && isHalfLine) {
            return `${styles.wHalf} ${styles.line} ${styles.lineCompleted}`;
        }
        const completed = isCompleted;
        return `${styles.line} ${completed ? styles.lineCompleted : styles.lineInactive}`;
    };

    return (
        <div className={`${styles.stepContainer} ${myAccount ? styles.myAccount : ''}`}>
            <div
                className={`${styles.step} ${
                    isActive ? styles.active : isCompleted ? styles.completed : styles.inactive
                }`}
                style={{ visibility: isVisible ? 'visible' : 'hidden' }}
            >
                {!myAccount && stepNumber}
            </div>

            {!isLast && <div className={lineClassName()} />}

            <div
                className={`${styles.label} ${
                    isActive ? styles.labelActive : isCompleted ? styles.labelCompleted : styles.labelInactive
                }`}
            >
                {label}
            </div>
        </div>
    );
};

export default ProgressStep;
